import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Home, Wind, Edit, BarChart2 } from 'lucide-react';
import windlarLogo from '../assets/windlar.png';

const SidebarContainer = styled.div`
  width: 250px;
  background: linear-gradient(135deg, #1a1f3a 0%, #0d1117 100%);
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.3);
  z-index: 100;
`;

const Logo = styled.div`
  padding: 0 20px 20px;
  margin-bottom: 20px;
  background: white;
  border-radius: 0;
  padding-top: 20px;
  
  img {
    width: 140px;
    height: auto;
  }
`;

const MenuSection = styled.div`
  padding: 10px 0;
`;

const MenuTitle = styled.div`
  padding: 10px 20px;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const MenuItem = styled(Link) <{ $active: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: ${props => props.$active ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(135deg, #00d4ff, #0099ff);
    opacity: ${props => props.$active ? 1 : 0};
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
    color: #fff;
    
    &:before {
      opacity: 1;
    }
  }
  
  svg {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    opacity: ${props => props.$active ? 1 : 0.7};
  }
`;

interface SidebarProps {
  className?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ className }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <SidebarContainer className={className}>
      <Logo>
        <img src={windlarLogo} alt="Windlar" />
      </Logo>

      <MenuSection>
        <MenuItem to="/" $active={isActive('/')}>
          <Home />
          Dashboard
        </MenuItem>

        <MenuTitle>Main Process</MenuTitle>

        <MenuItem to="/wind-farms" $active={isActive('/wind-farms')}>
          <Wind />
          Wind Farms
        </MenuItem>

        <MenuItem to="/turbines" $active={isActive('/turbines')}>
          <Edit />
          Turbines
        </MenuItem>

        <MenuItem to="/inspections" $active={isActive('/inspections')}>
          <Edit />
          Inspections
        </MenuItem>


      </MenuSection>
    </SidebarContainer>
  );
};

export default Sidebar;
